import { combineReducers } from "redux";
import { bodyGradientReducer, borderRadiusReducer, boxLayoutReducer, iconColorReducer, monochromeReducer, strokeReducer, themeModeReducer, themeReducer } from './settingsReducers';
import { roomTypeReducer } from './Room/roomTypeReducer';
import { amenityReducer } from "./Room/amenityReducer";
import { OfferListReducer } from './RoomOffers/OfferListReducer';
import { roomReservationReducer } from "./RoomReservation/RoomReservationReducer";
import { frontDeskReducer } from "./Frontdesk/dashboardReducers";
import {guestDetailReducer} from  "./Guests/GuestReducer"
import { restaurantReducer } from "./Restaurants/RestaurantsReducer";
import {tableReducer} from './Table/TableReducer';
import {ReservationTableReducer} from './Table/TableReservationReducer';
import {orderReducer} from './Order/OrderReducers';
import { departmentReducer} from './Departments/DepartmentsReducer';
import authReducer from './authReducer';
import { DashboardReducer } from "./Dashboard/DashboardReducer";
import { procurementReducer } from "./Procurements/ProcuremetReduceer";
import { SettingsReducer } from "./Settings/SettingsReducer";


const rootReducer = combineReducers({
    themeMode: themeModeReducer,
    theme: themeReducer,
    stroke: strokeReducer,
    boxLayout: boxLayoutReducer,
    monochrome: monochromeReducer,
    borderRadius: borderRadiusReducer,
    iconColor: iconColorReducer,
    gradientColor: bodyGradientReducer,
    roomType: roomTypeReducer,
    amenity: amenityReducer,
    offerList:OfferListReducer,
    roomReservationList:roomReservationReducer,
    frontdesk:frontDeskReducer,
    guestDetails:guestDetailReducer,
    restaurant:restaurantReducer,
    table:tableReducer,
    ReservationTable:ReservationTableReducer,
    order:orderReducer,
    department:departmentReducer,
    auth: authReducer,
    dashBoard:DashboardReducer,
    procurement:procurementReducer,
    settings:SettingsReducer,
});

export default rootReducer;